module.exports = __webpack_public_path__ + "img/avatar-example.db0ef574.png";